import script from "./MenuPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPhone.vue?vue&type=script&setup=true&lang=js"

import "./MenuPhone.vue?vue&type=style&index=0&id=d9310ef8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9310ef8"]])

export default __exports__